import * as yup from "yup";

// Step 1 Schema

export const vendorStep1Schema = yup.object().shape({
  logo: yup
    .mixed()
    .required("Logo is required")
    .test("fileSize", "File size must be less than 5MB", (value) => {
      if (!value || !(value instanceof File)) return true; // ALLOW EMPTY
      return value.size <= 5 * 1024 * 1024;
    })
    .test("fileType", "Only JPG and PNG files are allowed", (value) => {
      if (!value || !(value instanceof File)) return true;
      return ["image/jpeg", "image/jpg", "image/png"].includes(value.type);
    }),

  businessName: yup.string().nullable().required("Business Name is required"),

  contactName: yup.string().nullable().required("Contact Name is required"),

  email: yup
    .string()
    .nullable()
    .required("Email is required")
    .email("Invalid email format"),

  password: yup
    .string()
    .nullable()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),

  businessDescription: yup
    .string()
    .nullable()
    .required("Business Description is required"),
});

// Step 2 Schema
export const vendorStep2Schema = yup.object().shape({
  einTaxId: yup.string().nullable().required("EIN Tax ID is required"),

  businessLicenseNumber: yup
    .string()
    .nullable()
    .required("Business License Number is required"),
  phone: yup.string().nullable().required("Phone is required"),

  businessAddress: yup
    .string()
    .nullable()
    .required("Business Address is required"),

  governmentId: yup
    .mixed()
    .nullable()
    .required("Government ID is required")
    .test("fileSize", "File size must be less than 5MB", (value) => {
      if (!value || !(value instanceof File)) return true;
      return value.size <= 5 * 1024 * 1024;
    })
    .test("fileType", "Only JPG and PNG files are allowed", (value) => {
      if (!value || !(value instanceof File)) return true;
      return ["image/jpeg", "image/jpg", "image/png"].includes(value.type);
    }),

  liabilityInsurance: yup
    .mixed()
    .nullable()
    .required("Liability Insurance is required")
    .test("fileSize", "File size must be less than 5MB", (value) => {
      if (!value || !(value instanceof File)) return true;
      return value.size <= 5 * 1024 * 1024;
    })
    .test("fileType", "Only JPG and PNG files are allowed", (value) => {
      if (!value || !(value instanceof File)) return true;
      return ["image/jpeg", "image/jpg", "image/png"].includes(value.type);
    }),

  agreeToTerms: yup.boolean().oneOf([true], "You must agree to the terms"),
});
